import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=02200dad&scoped=true&"
import script from "./Icon.vue?vue&type=script&lang=ts&"
export * from "./Icon.vue?vue&type=script&lang=ts&"
import style0 from "./Icon.vue?vue&type=style&index=0&id=02200dad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02200dad",
  null
  
)

export default component.exports